module.exports = __webpack_public_path__ + "static/media/mobile02.5f57c644.jpg";